/* eslint-disable @typescript-eslint/no-use-before-define */
import CardSubCategories from '../components/CardSubCategories'
import React, { useEffect } from 'react'
import PageTitle from '../components/PageTitle'
import Head from 'next/head'

import { InferGetServerSidePropsType } from 'next'
import getConfig from 'next/config'
import { setPageViewData } from '../utils/analytics'

const Categories = ({ categories }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  useEffect(() => {
    setPageViewData('Categories', 'Other')
  }, [])
  return (
    <div id="main-content" className="categories">
      <Head>
        <title>All Categories</title>
        <meta name="description" content={'All categories details'} />
      </Head>
      <PageTitle title="All Categories" />
      <div className="categories__grid">
        {categories
          ?.filter((category) => category.is_displayed)
          ?.map((category) => (
            <CardSubCategories
              key={category.key}
              title={category.name}
              slug={category.slug}
              dynamicMediaUrl={category.dynamicMediaUrl}
              image={category['circle-image']}
              link={category.path}
              campaignName={category?.campaign_name}
              dateReference={category?.date_reference}
            />
          ))}
      </div>
    </div>
  )
}

export default Categories

export const getServerSideProps = async () => {
  const { publicRuntimeConfig } = getConfig()

  const res = await fetch(
    `${publicRuntimeConfig.APP_ENDPOINT}/api/productinfo/${publicRuntimeConfig.ENV}/parentcategories?popkey=${publicRuntimeConfig.POP_KEY}&returnNoIndexPages=false`,
    {
      headers: {
        deviceid: ''
      }
    }
  )
  const categories = await res.json()
  return {
    props: {
      categories: categories[0].template
    }
  }
}
